import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { LeadGenDetailShell } from "@/features/lead-gen/components/LeadGenDetailShell";
import { TemplateEditorForm } from "@/features/lead-gen/components/TemplateEditorForm";
import { useLeadGen } from "@/features/lead-gen/LeadGenContext";
import { useNav } from "@/utils/nav";

export const Route = createFileRoute("/_app/sales/leads/templates/$templateId")({
    component: LeadTemplateDetailPage,
});

function LeadTemplateDetailPage() {
    const { templateId } = Route.useParams();
    const { templates, setTemplates, artifacts } = useLeadGen();
    const navigate = useNavigate();
    const template = templates.find((item) => item.id === templateId) ?? null;

    useNav([
        { label: "Sales", route: { to: "/sales/leads" } },
        { label: "Leads", route: { to: "/sales/leads" } },
        { label: "Templates", route: { to: "/sales/leads/templates" } },
        {
            label: template?.name ?? "Template",
            route: { to: "/sales/leads/templates/$templateId", params: { templateId } },
        },
    ]);

    if (!template) {
        return (
            <LeadGenDetailShell
                backTo="/sales/leads/templates"
                backLabel="All templates"
                summary={<p className="text-slate-500 text-sm">This template may have been deleted.</p>}
            >
                <p className="bg-white/70 p-6 border border-slate-200 rounded-lg text-slate-500 text-sm text-center">
                    Template not found.
                </p>
            </LeadGenDetailShell>
        );
    }

    return (
        <LeadGenDetailShell
            backTo="/sales/leads/templates"
            backLabel="All templates"
            summary={
                <div className="flex items-center gap-2 min-w-0">
                    <span className="font-medium text-slate-800 text-lg truncate">{template.name}</span>
                    <span className="text-slate-500 text-sm">
                        Changes apply the next time you add leads with this template.
                    </span>
                </div>
            }
        >
            <TemplateEditorForm
                template={template}
                artifacts={artifacts}
                onCancel={() => void navigate({ to: "/sales/leads/templates" })}
                onSave={(next) => {
                    setTemplates((current) => {
                        const merged = current.map((item) => (item.id === next.id ? next : item));
                        return next.is_default
                            ? merged.map((item) => ({
                                  ...item,
                                  is_default: item.id === next.id,
                              }))
                            : merged;
                    });
                }}
            />
        </LeadGenDetailShell>
    );
}
